"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_IMAGE_URL = exports.GOOGLE_DEFAULT_LANGUAGE = exports.GOOGLE_MAPS_API_URL = void 0;
// google maps
exports.GOOGLE_MAPS_API_URL = "https://maps.googleapis.com/maps/api/";
exports.GOOGLE_DEFAULT_LANGUAGE = "en";
exports.BASE_IMAGE_URL = "https://daytrip2.imgix.net";
//# sourceMappingURL=config.js.map